/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-09-05 10:56:20
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-09-05 10:56:30
 * @FilePath: \ioc_base\src\modules\securityShift\api\api.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import fetch from "@src/common/lib/axios";
const API = {
  queryLogList: "bas/security/queryRelieveGuardList.json"
};

export default API;
